export default "__VITE_ASSET__00bc0496__"